import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipComponent } from './chip/chip.component';
import { ButtonComponent } from './button/button.component';
import { DrawerComponent } from './drawer/drawer.component';
import { StatusChipComponent } from './status-chip/status-chip.component';
import { MatChip } from "@angular/material/chips";
import { ByKeyPipe } from '../../pipes/by-key.pipe';

@NgModule({
  imports: [
    CommonModule,
    MatChip,
],
  declarations: [
    ChipComponent,
    ButtonComponent,
    DrawerComponent,
    StatusChipComponent,
    ByKeyPipe
  ],
  exports: [
    ChipComponent,
    ButtonComponent,
    DrawerComponent,
    StatusChipComponent,
    ByKeyPipe
    ]
})
export class GenericModule { }
